import { yupResolver } from '@hookform/resolvers/yup';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { fetchReports } from '../../api';
import { exportDataSchema } from '../../utils';
import { Button, FormInput, Modal } from '..';

const TableExportData = ({ dataToExport, closeModal, exportUrl = '' }) => {
  const [isLoading, setIsLoading] = useState(false);

  const todaysDate = format(new Date(), 'yyyy-MM-dd');

  const minMaxProps = {
    min: '2021-12-01',
    // It should be impossible to have data beyond the current date
    max: todaysDate
  };

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(exportDataSchema)
  });

  const downloadData = async (data) => {
    setIsLoading(true);
    try {
      const { from, to } = data;

      let dataToExportName = dataToExport.toLowerCase();
      const dataExportBase =
        exportUrl || dataToExportName.substring(0, dataToExportName.length - 1);
      const exportedData = await fetchReports(dataExportBase, from, to);

      const blob = new Blob([exportedData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${dataToExportName}_from_${from}_to_${to}.csv`;
      link.click();
      closeModal();
    } catch (error) {
      const { message } = error?.data ?? {};

      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal header={{ name: 'Export', cursive: 'File' }} onModalClose={closeModal}>
      <form onSubmit={handleSubmit(downloadData)}>
        <FormInput
          placeholder="Select date"
          label="From"
          name="from"
          register={register('from')}
          error={errors?.from?.message}
          type="date"
          {...minMaxProps}
        />

        <FormInput
          label="To"
          placeholder="Select date"
          name="to"
          register={register('to')}
          error={errors?.to?.message}
          type="date"
          {...minMaxProps}
        />

        <Button isFull isLoading={isLoading}>
          Download as CSV
        </Button>
        {/* <Button isFull variant="outline">
          Download as PDF
        </Button> */}
      </form>
    </Modal>
  );
};

TableExportData.propTypes = {
  closeModal: PropTypes.func,
  dataToExport: PropTypes.string
};
export { TableExportData };
